<template lang='pug'>
//- Side-Effect-Page
div(:class='$style[`cc-side-effect-user`]')
  div(v-if='!isConsultInnerRoom && rwdType === `desktop`' :class='$style[`cc-side-effect-user-topper`]')
    div(:class='$style[`cc-side-effect-user-board`]')
      div(:class='$style[`cc-side-effect-user-profile`]')
        div(:class='$style[`cc-side-effect-user-welcome`]')
          span.font-bold(v-if='$route.name === `effect-record`') 副作用紀錄
          span.font-bold(v-else-if='$route.name === `effect-post`') 建立新記錄
          span.font-bold(v-else-if='$route.name === `effect-consult`') 線上諮詢室
          //- span.font-bold(v-else-if='$route.name === `effect-aidoctor`') QA問答庫
          span.font-bold(v-else-if='$route.name === `effect-translator`') 報告翻譯
          span.font-bold(v-else-if='$route.name === `effect-profile`') 我的病歷資料

      div(:class='$style[`cc-side-effect-user-post`]')
        router-link.font-medium.btn-normal-extra(
          role='button'
          tabindex='0'
          aria-label='建立新記錄'
          to='/sideeffect/post'
          :class='$style[`cc-side-effect-user-post-btn`]') + 新記錄

        //- button.font-medium(
        //-   tabindex='0' aria-label='抗癌金句'
        //-   :class='$style[`cc-side-effect-user-post-knowledge`]'
        //-   @click='handleClickToShowGoldKnowledge')
        //-   IconIdeas(:size='20')
        //-   span 抗癌金句

    //- 平板/手機
    //- div(v-else :class='$style[`cc-side-effect-user-board-mobile`]')
    //-   div(:class='$style[`cc-side-effect-user-profile`]')
    //-     div(:class='$style[`cc-side-effect-user-profile-thumb`]')
    //-       //- div(v-if='loginProfile.verified === `yes`' :class='[$style[`cc-side-effect-profile-verify`], $style[`cc-is-verify`]]')
    //-       //-   div(:class='$style[`cc-side-effect-profile-verify-icon`]')
    //-       //-     IconConfirm(:size='10' :color='`#fff`')

    //-       //- div(v-else :class='$style[`cc-side-effect-profile-verify`]')
    //-       //-   div(:class='$style[`cc-side-effect-profile-verify-icon`]')
    //-       //-     IconConfirm(:size='10' :color='`#fff`')

    //-       figure(v-if='loginProfile.thumbSrc === `` && !loginProfile.public' :class='$style[`cc-side-effect-profile-board-avatar`]')
    //-         img(
    //-           v-if='loginProfile.gender === `0`'
    //-           :src='`${STATIC_URL}images/common/user/normal_male.webp`'
    //-           width='100%'
    //-           height='100%')
    //-         img(
    //-           v-else
    //-           :src='`${STATIC_URL}images/common/user/normal_female.webp`'
    //-           width='100%'
    //-           height='100%')

    //-       figure(v-else-if='loginProfile.thumbSrc !== `` && !loginProfile.public' :class='$style[`cc-side-effect-profile-board-avatar`]')
    //-         img(
    //-           v-if='loginProfile.gender === `0`'
    //-           :src='`${STATIC_URL}images/common/user/normal_male.webp`'
    //-           width='100%'
    //-           height='100%')
    //-         img(
    //-           v-else
    //-           :src='`${STATIC_URL}images/common/user/normal_female.webp`'
    //-           width='100%'
    //-           height='100%')

    //-       figure(v-else-if='loginProfile.thumbSrc === `` && loginProfile.public' :class='$style[`cc-side-effect-profile-board-avatar`]')
    //-         img(
    //-           v-if='loginProfile.gender === `0`'
    //-           :src='`${STATIC_URL}images/common/user/normal_male.webp`'
    //-           width='100%'
    //-           height='100%')
    //-         img(
    //-           v-else
    //-           :src='`${STATIC_URL}images/common/user/normal_female.webp`'
    //-           width='100%'
    //-           height='100%')

    //-       figure(v-else-if='loginProfile.thumbSrc !== `` && loginProfile.public' :class='$style[`cc-side-effect-profile-board-avatar`]')
    //-         img(
    //-           :src='avatarSrcLink(loginProfile.thumbSrc)'
    //-           width='100%'
    //-           height='100%')
   
   
    //-     div(:class='$style[`cc-side-effect-user-dashboard`]')
    //-       div(:class='$style[`cc-side-effect-user-welcome`]')
    //-         span.font-bold(v-if='$route.name === `effect-record`') 副作用紀錄
    //-         span.font-bold(v-else-if='$route.name === `effect-post`') 建立新記錄
    //-         span.font-bold(v-else-if='$route.name === `effect-consult`') 線上諮詢室
    //-         //- span.font-bold(v-else-if='$route.name === `effect-aidoctor`') QA問答庫
    //-         span.font-bold(v-else-if='$route.name === `effect-translator`') 報告翻譯
    //-         span.font-bold(v-else-if='$route.name === `effect-profile`') 我的病歷資料

    //-       //- div(:class='$style[`cc-side-effect-user-status`]')
    //-       //-   div(:class='$style[`cc-side-effect-sidebar-score`]')
    //-       //-     nav(:class='$style[`cc-side-effect-sidebar-score-nav`]')
    //-       //-       span.border-gradient(v-if='subscribeVip === `yes`' :class='$style[`cc-side-effect-sidebar-score-nav-vip`]') VIP會員
    //-       //-       span(v-else :class='$style[`cc-side-effect-sidebar-score-nav-free`]') 基本會員
    //-       //-     nav(:class='$style[`cc-side-effect-sidebar-score-nav`]')
    //-       //-       IconCcoin(:size='24')
    //-       //-       span.font-medium(v-if='loginProfile.point' :class='$style[`cc-side-effect-sidebar-score-nav-coin`]') {{ loginProfile.point }}
    //-       //-         span.font-regular(:class='$style[`cc-detail-status-hp-tips`]') 幣
    //-       //-       span.font-medium(v-else :class='$style[`cc-side-effect-sidebar-score-nav-coin`]') 0
    //-       //-         span.font-regular(:class='$style[`cc-detail-status-hp-tips`]') 幣
  
    //-   div(:class='$style[`cc-side-effect-user-post`]')
    //-     router-link.font-medium.btn-normal-extra(
    //-       role='button'
    //-       tabindex='0'
    //-       aria-label='建立新記錄'
    //-       to='/sideeffect/post'
    //-       :class='$style[`cc-side-effect-user-post-btn`]') + 新記錄

    //-     //- router-link.font-medium(
    //-     //-   role='button'
    //-     //-   tabindex='0'
    //-     //-   aria-label='病歷資料'
    //-     //-   to='/ecard'
    //-     //-   :class='$style[`cc-side-effect-user-post-myprofile`]') 我的病歷

    //-     button.font-medium(
    //-       tabindex='0' aria-label='抗癌金句'
    //-       :class='$style[`cc-side-effect-user-post-knowledge`]'
    //-       @click='handleClickToShowGoldKnowledge')
    //-       IconIdeas(:size='20')
    //-       span 抗癌金句
  
  div(v-if='!isConsultInnerRoom' :class='$style[`cc-side-effect-analysis`]')
    div(v-if='!analysisAnimate' :class='$style[`cc-side-effect-analysis-block`]')
      header(:class='$style[`cc-side-effect-analysis-header`]')
        span.font-bold(:class='$style[`cc-side-effect-analysis-title`]') 健檢與預測
        span.font-regular(:class='$style[`cc-side-effect-analysis-tip`]') 每完成4次紀錄自動執行

      div(v-if='subscribeVip === `yes`' :class='$style[`cc-side-effect-analysis-main`]')
        ProgressBar(
          :loadAnimate='false'
          :labelValue='analysisAnimateInput ? loginProfile.analysis_count : 0')
        div(:class='$style[`cc-side-effect-analysis-counter`]')
          span 還缺{{ 4 - loginProfile.analysis_count }}筆
      div(v-else :class='$style[`cc-side-effect-analysis-main`]')
        ProgressBar(
          :loadAnimate='false'
          :labelValue='0')
        div(:class='$style[`cc-side-effect-analysis-counter`]')
          IconLocker(:size='16' :color='`#999`')
          span 請先訂閱

    div(v-else :class='$style[`cc-side-effect-analysis-block`]')
      header(:class='$style[`cc-side-effect-analysis-header`]')
        span.font-bold(:class='$style[`cc-side-effect-analysis-title`]') 正在預測分析
        span.font-regular(:class='$style[`cc-side-effect-analysis-tip`]') 請耐心等候
      div(:class='$style[`cc-side-effect-analysis-main`]')
        ProgressBar(
          :loadAnimate='true'
          :labelValue='0')
        div(:class='$style[`cc-side-effect-analysis-counter`]')
          span 分析中

  div(:class='$style[`cc-side-effect-user-container`]')
    router-view


</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import GlobalEmitter from 'tiny-emitter/instance';

// import { mixin as clickaway } from 'vue-clickaway';
import IconCcoin from '../../icon/Ccoin';
import IconIdeas from '../../icon/Ideas';
import IconConfirm from '../../icon/Confirm';
import IconLocker from '../../icon/Locker';
import ProgressBar from '../common/ProgressBar';
// import { debounce } from 'debounce';

export default {
  components: {
    IconCcoin,
    IconIdeas,
    IconConfirm,
    IconLocker,
    ProgressBar,
  },

  // mixins: [clickaway],

  created() {
    this.detectGlobalEmitter();
    this.initRoomWebsocket();
  },

  beforeDestroy() {
    this.closeWebSocket();
    window.removeEventListener('beforeunload', e => this.closeWebSocket(e));
  },

  data() {
    return {
      analysisAnimate: false,
      analysisAnimateInput: false,
      wsRoom: null,
      // wsReadState: 0,
      errorDetect: false,
      hideConsultationBoard: false,
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopTranslatorStatus: 'global/POPTRANSLATOR_STATUS',
      changePopAnalysisStatus: 'global/POPANALYSIS_STATUS',
      changePopDeleteTranslationStatus: 'global/POPDELETE_TRANSLATION_STATUS',
      changePopShowTutorialStatus: 'global/POPSHOW_TUTORIAL_STATUS',
      changePopProgressStatus: 'global/POPPROGRESS_STATUS',
      updateExclusiveWebSocket: 'user/EXCLUSIVE_WEBSOCKET',
    }),

    detectGlobalEmitter() {
      let vm = this;
      GlobalEmitter.on('start-prediction', function (arg) {
        vm.analysisAnimate = arg.analysis;
      });

      setTimeout(() => {
        this.analysisAnimateInput = true;
      }, 100);
    },

    closeWebSocket(e) {
      if (this.wsRoom) {
        this.wsRoom.close();
      }
    },

    initRoomWebsocket() {
      if (process.env.NODE_ENV === 'production') {
        this.wsRoom = new WebSocket(`${this.WS_HEAD}://${window.location.host}/ws/0-${this.loginHashCode}-${this.loginDjangoId}/`);
      } else {
        this.wsRoom = new WebSocket(`${'https:' === document.location.protocol ? 'ws' : 'ws'}:${process.env.VUE_APP_BACKEND}/ws/0-${this.loginHashCode}-${this.loginDjangoId}/`);
      }

      // this.updateExclusiveWebSocket({
      //   ws: this.wsRoom,
      //   room: `0-${this.loginHashCode}-${this.loginDjangoId}`
      // });

      this.wsRoom.onopen = this.wsonopen;
      this.wsRoom.onmessage = this.wsonmessage;
      this.wsRoom.onerror = this.wsonerror;
      this.wsRoom.onclose = this.wsclose;
      // console.log('WebSocket Board', this.wsRoom, this.wsRoom.readyState);
    },

    wsonopen() {
      // this.wsReadState = this.wsRoom.readyState;
      this.errorDetect = false;
      // console.log('WS Board 連線成功!', this.wsRoom.readyState);
    },

    wsonerror(e) {
      // this.wsReadState = 3;
      this.errorDetect = true;
      // console.error('WS 連線失敗!', e);
    },

    wsclose() {
      // this.wsReadState = 3;
      this.errorDetect = true;
      // console.log('WS Board 關閉連線', this.wsRoom.readyState);
    },

    wsonmessage(e) {
      if (this.errorDetect) {
        this.wsRoom = null;
        this.changePopBoxStatus({
          active: true,
          include: 'warnWebSocketError',
        });
        return;
      }

      let _data = JSON.parse(e.data);
      console.log('wsonmessage', _data);

      this.changePopProgressStatus({
        active: false,
        feature: '',
      });

      // if (_data.chatgpt.match(/translate|photo_translate/g)) {
      if (_data.chatgpt === 'translate' || _data.chatgpt === 'photo_translate') {
        // GlobalEmitter.emit('create-translation', {
        //   id: _data.create_id,
        //   auth_id: this.loginDjangoId,
        //   date: _data.create_date,
        //   language: _data.language,
        //   origin: _data.origin,
        //   short: _data.short || '我的新翻譯紀錄',
        //   completion: _data.message
        // });

        this.changePopTranslatorStatus({
          active: true,
          detail: {
            index: null,
            feature: 'create',
            id: _data.create_id,
            language: _data.language,
            date: _data.create_date,
            short: _data.short || null,
            completion: _data.message,
            origin: _data.origin,
          }
        });

      } else if (_data.chatgpt === 'unrecognized') {
        this.changePopBoxStatus({
          active: true,
          include: 'warnUnrecognized',
        });

      } else if (_data.chatgpt === 'analysis') {
        const msg = _data.message;
        this.analysisAnimate = false;

        this.changePopAnalysisStatus({
          active: true,
          detail: {
            id: msg.id,
            evalaute: '',
            start_date: msg.start_date,
            end_date: '',
            category: msg.category,
            broadcast: msg.broadcast,
            reminder: msg.reminder,
            prediction: msg.prediction,
            suggestion: msg.suggestion,
            summary: msg.summary,
            course: msg.course,
            // tag: msg.tag,
          }
        });
        GlobalEmitter.emit('reload-analysis');

      } else if (_data.chatgpt === 'prediction') {

        const msg = _data.message;
        this.analysisAnimate = false;

        this.changePopAnalysisStatus({
          active: true,
          detail: {
            id: msg.id,
            evalaute: '',
            start_date: msg.start_date,
            end_date: msg.end_date,
            category: msg.category,
            broadcast: msg.broadcast,
            reminder: msg.reminder,
            prediction: msg.prediction,
            suggestion: msg.suggestion,
            summary: msg.summary,
            course: msg.course,
            // tag: msg.tag,
          }
        });
        GlobalEmitter.emit('reload-analysis');

      } else if (_data.chatgpt === 'drcell_error') {
        this.analysisAnimate = false;
        this.changePopBoxStatus({
          active: true,
          include: 'warnDrcellError',
        });
      }
    },

    // handleClickToShowGoldKnowledge() {
    //   this.changePopShowTutorialStatus({
    //     active: true,
    //     include: 'gold-knowledge',
    //   });
    // }
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
      loginDjangoId: 'user/exportUserDjangoId',
      loginProfile: 'user/exportUserProfile',
      loginStatus: 'user/exportLoginStatus',
      loginHashCode: 'user/exportUserHashCode',
      loginSubscribeValid: 'user/exportUserSubscribeValid',
      subscribeVip: 'user/exportUserSubscribeVip',
    }),

    isConsultInnerRoom() {
      const router = this.$route;
      return router.name === 'effect-consult' && router.query.v ? true : false;
    }

    // errorDetect() {
    //   return !this.wsRoom || this.wsReadState === 3;
    // },
  },

  watch: {
    errorDetect() {
      if (this.errorDetect) {
        console.log('errorDetect 偵測到錯誤!');
        this.wsRoom = null;

        setTimeout(() => {
          this.changePopBoxStatus({
            active: true,
            include: 'warnWebSocketError',
          });
        }, 2000);
      }
    },

    // $route(to, from) {    
    //   console.log('route', this.$route);

    //   if (to.name === 'effect-consult' && to.query.v) {
    //     alert('detect effect consult room')
    //   }
    // },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effectBoard.scss';
</style>
